"use strict";

applicationSlider.classy.controller({
    name: "InterestSliderController",
    inject: ['$scope', '$timeout', 'AlertService', '$sce', '$timeout', 'ApplicationService', '$q', '$http',
    	'CalculationService', 'ApWizardModelFactory', 'ResetService', 'focus', 'CheckListService', 
    	'PermissionModelService', 'authServiceFactory', 'SliderService'],
    init: function()
    {
        this.$.SliderService = this.SliderService;
        this.$.CheckListService = this.CheckListService;
        this.$.isArchive = this.ApplicationService.getAwardData().isArchive;
        this.setEdited();
        this.$timeout(function() {
            var $window = $(window).on('resize', function(){
                var height = $(this).height() - 125;
                $('.checklist-content-area').css("max-height", height + 'px');
            }).trigger('resize');
        }, 300);
        for (var i = 0; i < this.$.SliderService.returnSliders().length; i++) {
            if (this.$.SliderService.returnSliders()[i].partial=="applicationSlider/partials/interestSlider") {
                this.$.slider = this.$.SliderService.returnSliders()[i];
                this.$.index = i;
            }
        }
    },
    watch: {
        '{object}this.CheckListService.interestSelected.id': function(newValue, oldValue) {
            this.setEdited();
        }
    },
    setEdited: function() {
        this.$.edited = [];
        if (this.$.CheckListService.interestSelected.notes!==undefined && this.$.CheckListService.interestSelected.notes!==null) {
            for (var i = 0; i < this.$.CheckListService.interestSelected.notes.length; i++) {
                this.$.edited[i] = 0;
            }
        }
    },
    update: function() {
    	var self = this;
    	//update existing record
    	if (this.CheckListService.interestSelected.class==undefined) {
    		this.CheckListService.interestSelected.weight = this.CheckListService.interestSelected.schoolweight
    	}
    	if (this.CheckListService.interestSelected.id) {
	    	var data = {
	    		'weight': this.CheckListService.interestSelected.schoolweight,
	    		'complete': this.CheckListService.interestSelected.complete,
	    		'completeDate': this.CheckListService.interestSelected.completeDate
	    	};
	    	this.$http.put("/api/FamIsmFlagss/" + this.CheckListService.interestSelected.id, data)
	    	.then(function(ret) {

	    	});
	    }
	    //insert new record
	    else {
	    	var data = {
	    		'familyID': this.ApplicationService.getFamilyData().edit_sums.familyID,
	    		'flagname': this.CheckListService.interestSelected.shortname,
	    		'weight': this.CheckListService.interestSelected.schoolweight,
	    		'complete': this.CheckListService.interestSelected.complete,
	    		'completeDate': this.CheckListService.interestSelected.completeDate,
                'deleted': 0
	    	};
            //Done to allow for no issues when putting new flags without weight or completeness
            if (data['weight']==null) 
                delete data['weight']
            if (data['complete']==null)
                delete data['complete']
	    	this.$http.post("/api/FamIsmFlagss", data)
	    	.then(function(ret) {
	    		self.CheckListService.interestSelected.id = ret.data.id;
	    	});
	    }
        //recalculate after update
	    this.CheckListService.getTotals();
    },
    closeIssue: function() {
    	this.CheckListService.complete.interest[this.CheckListService.interestSelected.shortname] = true;
    	this.CheckListService.interestSelected.complete=1;
    	this.CheckListService.interestSelected.completeDate="NOW()";
    	this.update();
        this.SliderService.closeSlider(this.$.index);
    },
    openIssue: function() {
    	this.CheckListService.complete.interest[this.CheckListService.interestSelected.shortname] = false;
    	this.CheckListService.interestSelected.complete=0;
    	this.CheckListService.interestSelected.completeDate=null;
    	this.update();
    },
    momentFormat: function(datetime)
    {
        var notetime = moment(datetime)
        return notetime.format('MMM Do, YYYY h:mm a');
    },
    newNote: function() {
        this.$.newItem = {'familyID': this.ApplicationService.getFamilyData().data[0].familyID, 'flagID': this.CheckListService.interestSelected.id, 
                            'text': '', 'userID': parseInt(this.authServiceFactory.getAuth().recordID), 'deleted': 0};
    },
    deleteNote: function(index) {
        var parent = this;
        swal({
            title: "Are you sure?",
            text: "This will delete the note you added to this flag.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, reset it!",
            closeOnConfirm: true
        },
        function(){
            parent.$.CheckListService.interestSelected.notes[index].deleted = 1;
            parent.$.CheckListService.interestSelected.notes[index].id = parseInt(parent.$.CheckListService.interestSelected.notes[index].id);
            parent.$http.put("/api/family/"+parent.$.CheckListService.interestSelected.notes[index].familyID+"/famIsmFlags/note", parent.$.CheckListService.interestSelected.notes[index]).then(function(results) {
                parent.$.CheckListService.interestSelected.notes.splice(index, 1);
            })
        });
    },
    saveNote: function(note, index) {
        var parent = this;
        if (index==undefined) {
            if (!this.CheckListService.interestSelected.id) {
                this.update()
            }
            this.$timeout(function() {
                parent.$.newItem.flagID = parent.CheckListService.interestSelected.id;
                parent.$http.put("/api/family/"+parent.$.newItem.familyID+"/famIsmFlags/note", parent.$.newItem).then(function(results) {
                    parent.$.newItem.id = results.data;
                    parent.$.newItem.dateChanged = moment();
                    if (parent.$.CheckListService.interestSelected.notes==undefined)
                            parent.$.CheckListService.interestSelected.notes = [];
                    parent.$.CheckListService.interestSelected.notes.push(parent.$.newItem);
                    parent.setEdited();
                    parent.newNote();
                });
            }, 1000)
        }
        else {
            note.userID = this.authServiceFactory.getAuth().recordID;
            this.$http.put("/api/family/"+note.familyID+"/famIsmFlags/note", note).then(function(results) {
                parent.$.CheckListService.interestSelected.notes[index] = note;
                parent.$.edited[index] = 0;
            });
        }
    }
});
